import { useEffect, useState } from "react";
import "./_cardRelatorio.scss";

function CardRelatorio({
    percent,
    estagio,
    description,
    descriptionStage,
    score,
    total_score,
    sector,
    percent_attendance,
    banchmark_percent_attendance,
    banchmark,
    showSectorData,
    showBenchmarkData,
    average,
}) {
    const [progressWidth, setProgressWidth] = useState(0);

    useEffect(() => {
        const minScore = 1.25;
        const maxScore = 5;
        const range = maxScore - minScore;
        const validAverage = Number(average) || minScore;

        let calculatedPercent = ((validAverage - minScore) / range) * 100;

        if (calculatedPercent > 100) calculatedPercent = 100;
        if (calculatedPercent < 0) calculatedPercent = 0;

        setProgressWidth(calculatedPercent);
    }, [average]);

    const getEstagioLevel = (str) => {
        if (!str) return 0;
        const normalized = str
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
        if (normalized === "referencia") return 4;
        if (normalized === "avancado") return 3;
        if (normalized === "intermediario") return 2;
        if (normalized === "iniciante") return 1;
        return 0;
    };

    const level = getEstagioLevel(estagio);

    return (
        <div className="card-relatorio">
            <h4>Resultado Geral</h4>
            <div className="card-relatorio__box-percentual">
                <div className="scale-progress" cor="red">
                    <div
                        className="scale-progress__fill-bg"
                        style={{ width: `${progressWidth}%` }}
                    ></div>
                    <div className="marcadores">
                        <div
                            className={`marcador marcador-inicial ${level >= 1 ? "check" : ""}`.trim()}
                        ></div>
                        <div
                            className={`marcador marcador-intermediario ${level >= 2 ? "check" : ""}`.trim()}
                        ></div>
                        <div
                            className={`marcador marcador-avancado ${level >= 3 ? "check" : ""}`.trim()}
                        ></div>
                        <div
                            className={`marcador marcador-referencia ${level >= 4 ? "check" : ""}`.trim()}
                        ></div>
                    </div>
                    <div className="description-stages">
                        <p className={level >= 1 ? "active" : ""}>Iniciante</p>
                        <p className={level >= 2 ? "active" : ""}>
                            Intermediário
                        </p>
                        <p className={level >= 3 ? "active" : ""}>Avançado</p>
                        <p className={level >= 4 ? "active" : ""}>Referência</p>
                    </div>
                </div>
                <span className="relatorio__company-result-percent">
                    {percent}%
                </span>

                <div className="relatorio__box-result">
                    <p>
                        Estágio:{" "}
                        <span className="style-uppercase">{estagio}</span>
                    </p>
                    <p>{descriptionStage}</p>
                </div>
            </div>

            <p className="pontuacao_empresa">
                <span>Pontuação da empresa:</span> {score} pontos
            </p>

            <p
                className="card-relatorio__description"
                dangerouslySetInnerHTML={{ __html: description }}
            ></p>

            {showSectorData && (
                <>
                    <p className="title-resultado-geral-setor">
                        Resultado Geral do Setor
                    </p>
                    <p className="pontuacao_empresa">
                        <span>Resultado do setor:</span> {sector} pontos
                        (mediana)
                    </p>
                    <p className="pontuacao_empresa">
                        <span>Percentual de atendimento:</span>{" "}
                        {percent_attendance}%
                    </p>
                </>
            )}

            {showBenchmarkData && (
                <>
                    <br />
                    <p className="title-resultado-geral-setor">
                        Resultado Benchmark
                    </p>
                    <p className="pontuacao_empresa">
                        <span>Resultado benchmark:</span> {banchmark} pontos
                        (média)
                    </p>
                    <p className="pontuacao_empresa">
                        <span>Percentual de atendimento:</span>{" "}
                        {banchmark_percent_attendance}%
                    </p>
                </>
            )}
            <br />
            <p className="pontuacao_total">
                <span>Nota1:</span> Pontuação máxima = {total_score} pontos
            </p>
            {showBenchmarkData && (
                <>
                    <p className="pontuacao_total">
                        <span>Nota2:</span> O resultado benchmark corresponde a
                        25% das maiores notas inseridas no sistema.
                    </p>
                </>
            )}
        </div>
    );
}

export default CardRelatorio;
